import React, { useContext } from 'react';
import { TouchableOpacity } from 'react-native';
import {
  ChannelInput as ChannelInputBase,
  GroupChannelContexts,
} from '@sendbird/uikit-react-native';
import { getGroupChannelChatAvailableState } from '@sendbird/uikit-utils';
import {
  Icon,
  createStyleSheet,
  useUIKitTheme,
} from '@sendbird/uikit-react-native-foundation';
import { useAuth } from 'app/auth/hooks/useAuth';
import { UploadDocumentModal } from 'app/_modules/history';
import { useChatUpload } from '../hooks/useChatUpload';


const ChannelInput = ChannelInputBase as React.ComponentType<any>;

type InputModuleProps = { inputDisabled?: boolean } & Record<string, any>;

const ChatGroupChannelInput: React.FC<InputModuleProps> = ({
  inputDisabled = false,
  ...props
}) => {
  const {
    channel,
    keyboardAvoidOffset = 0,
    messageToEdit,
    setMessageToEdit,
    messageToReply,
    setMessageToReply,
  } = useContext(GroupChannelContexts.Fragment);

  const chatAvailableState = getGroupChannelChatAvailableState(channel);

  const { meData } = useAuth();
  const pathwayId = meData?.current_pathway?.id ?? '';
  const { colors } = useUIKitTheme();

  const upload = useChatUpload(pathwayId, props.onPressSendFileMessage);

  return (
    <>
      <ChannelInput
        channel={channel}
        messageToEdit={messageToEdit}
        setMessageToEdit={setMessageToEdit}
        messageToReply={messageToReply}
        setMessageToReply={setMessageToReply}
        keyboardAvoidOffset={keyboardAvoidOffset}
        inputMuted={chatAvailableState.muted}
        inputFrozen={chatAvailableState.frozen}
        inputDisabled={chatAvailableState.disabled ? true : inputDisabled}
        {...props}
        AttachmentsButton={({ disabled }: { disabled: boolean }) => (
          <TouchableOpacity
            onPress={() => upload.setIsUploadModalVisible(true)}
            disabled={disabled || upload.isUploading}
            style={styles.attachButton}
          >
            <Icon
              icon="add"
              size={24}
              color={
                disabled || upload.isUploading
                  ? colors.ui.input.default.disabled.highlight
                  : colors.ui.input.default.active.highlight
              }
            />
          </TouchableOpacity>
        )}
      />

      <UploadDocumentModal
        visible={upload.isUploadModalVisible}
        onClose={() => upload.setIsUploadModalVisible(false)}
        onSelectCamera={upload.handleCameraUpload}
        onSelectExternalDevice={upload.handleExternalDeviceUpload}
      />
    </>
  );
};

export default React.memo(ChatGroupChannelInput);

const styles = createStyleSheet({
  attachButton: {
    marginEnd: 8,
    padding: 4,
  },
});
